import call from '@gov.wa.lni/application.warehouse-retaliation/source/interactions/call.js';

export default {
    call,
};